import { dapvApi } from 'services/providers/dapv';
import { AddOrEditStakeholderPayload, AddOrEditStakeholderResponse } from './stakeholder.types';
import { ApiResponse } from 'services/providers/dapv.types';
import { GetPersonStakeholderPayload } from '../person.types';
import { GetPersonStakeholderResponse } from '../person.types';

const requestApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        addOrUpdateUserStakeholder: build.mutation<AddOrEditStakeholderResponse, AddOrEditStakeholderPayload>({
            query: ({ id, body }: AddOrEditStakeholderPayload) => {

                return {
                    url: `/app/persons/${id}/stakeholders`,
                    method: 'POST',
                    body
                };
            },
            transformResponse: (response: AddOrEditStakeholderResponse) => response
        }),
        getPersonStakeholder: build.mutation<ApiResponse<GetPersonStakeholderResponse>, GetPersonStakeholderPayload>({
            query: ({ id, stakeholderId }: GetPersonStakeholderPayload) => {
                return {
                    url: `/app/persons/${id}/stakeholders/${stakeholderId}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<GetPersonStakeholderResponse>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
    })
});

export const { useAddOrUpdateUserStakeholderMutation, useGetPersonStakeholderMutation } = requestApi;
